(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/prescript.js'); 
'use strict';

svs.competition = svs.competition || {};
svs.competition.core = svs.competition.core || {};
svs.competition.core.models = svs.competition.core.models || {};
svs.competition.core.collections = svs.competition.core.collections || {};
svs.competition.core.views = svs.competition.core.views || {};
svs.competition.core.templates = svs.competition.core.templates || {};
svs.competition.core.data = svs.competition.core.data || {};

 })(window);